import Vue from "vue";
import axios from "axios";
import { requestTimeout, contentType, deviceType } from "@/config/index";
import { baseURL } from "@/config/index";
import store from "@/store";

let loadingInstance;
/**
 * @author
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */

const handleCode = (errorcode, message, debuginfo) => {
  let errorMsg = "";
  switch (errorcode) {
    case "invalidtoken": // 令牌无效
      break;
    case "errorcoursecontextnotvalid": // 令牌无效
      errorMsg = "对不起，你没权限查看该课程或活动";
      break;
    case "invalidparameter": // 令牌无效
      errorMsg = message === "检测到无效的参数值" ? debuginfo : "缺少必要参数";
      break;
    case "invalidrecord":
      errorMsg = "找不到记录";
      break;
    default:
      break;
  }
  Vue.prototype.$message.error(errorMsg || message);
};
// const isDev = process.env.NODE_ENV === "development";
const instance = axios.create({
  baseURL: baseURL,
  timeout: requestTimeout,
  headers: {
    "Content-Type": contentType,
    "Device-Type": deviceType,
  },
});
instance.interceptors.request.use(
  (config) => {
    // console.log("config", config);
    let moodleParams = {
      moodlewsrestformat: "json",
      wsfunction: config.url,
    };
    // 如果token存在，带上下面的信息
    if (store.state.user.accessToken) {
      moodleParams.wstoken = store.state.user.accessToken;
    }
    config.params = { ...moodleParams, ...config.params };
    //这里会过滤所有为空、0、false的key，如果不需要请自行注释
    // if (config.data) config.data = Vue.prototype.$baseLodash.pickBy(config.data, Vue.prototype.$baseLodash.identity)
    if (
      config.data &&
      config.headers["Content-Type"] ===
        "application/x-www-form-urlencoded;charset=UTF-8"
    )
      if (
        config.data &&
        config.headers["Content-Type"] === "multipart/form-data"
      )
        config.headers["Content-Type"] = "multipart/form-data";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close();
    // console.log('response', response)
    const { errorcode, message, debuginfo } = response.data;
    // console.log("errorcode", errorcode);
    // console.log("message", message);
    if (errorcode) {
      handleCode(errorcode, message, debuginfo);
      return Promise.reject(response.data);
    } else {
      return response.data; // 请求成功之后将返回值返回
    }
  },
  (error) => {
    if (loadingInstance) loadingInstance.close();
    // const { response, message } = error;
    return Promise.reject(error);
    // if (error.response && error.response.data) {
    //   const { status, data } = response;
    //   handleCode(status, data.msg || message);
    //   return Promise.reject(error);
    // } else {
    //   let { message } = error;
    //   if (message === "Network Error") {
    //     message = "后端接口连接异常";
    //   }
    //   if (message.includes("timeout")) {
    //     message = "后端接口请求超时";
    //   }
    //   if (message.includes("Request failed with status code")) {
    //     const code = message.substr(message.length - 3);
    //     message = "后端接口" + code + "异常";
    //   }
    //   // Vue.prototype.$baseMessage(message || `后端接口未知异常`, "error");
    //   console.log("提示报错3", message + `:后端接口未知异常`);
    //   return Promise.reject(error);
    // }
  }
);

export default instance;
